export default __webpack_public_path__ + "static/media/app.51829c6a.svg";